"use client";

import React, { useEffect, useState } from "react";
import Sites from "../../constants/Sites";
import { useAppContext } from "@components/Provider";
import { useTabletDetection } from "helpers/useTabletDetection";
import Header from "@components/Header/Header";
import styles from './LayoutWithoutAds.module.css';
import NewHeader from '../Header/NewHeader';
import Footer from "@components/Footer";
import RightRailAds from "@components/Ads/RightRailAds/RightRailAds";
import { isIPadProOnSafari } from "helpers/Helper";
import TagManager from "react-gtm-module";
import ContentHeader from "@components/HeaderPage/ContentHeader";
import CatalogHeader from "@components/HeaderPage/CatalogHeader";


// const NewHeader = dynamic(() => import("../Header/NewHeader"), {
//   ssr: false,
// });

// const renderRightRail = ({
//   className,
//   stickyTop,
//   bottomBoundary,
//   isMobile,
//   isTablet,
//   isIpadpro,
// }) => {
//   if (!isMobile && !isTablet && !isIpadpro) {
//     return (
//     //   <div className={className || ""}>
//     //   <Sticky bottomBoundary={bottomBoundary} top={stickyTop}>
//     //     <Link href="/newsletters">
//     //       <NextImage
//     //         ImageUrl={`${process.env.S3_IMAGE_URL}/EBB_NL_Signup_Sidebar_Design.png`}
//     //         alt="Subscribe to EBB"
//     //         title="Subscribe to EBB"
//     //         width={310}
//     //         height={400}
//     //       />
//     //     </Link>
//     //   </Sticky>
//     //   {/* Use the CSS module class here */}
//     //   <div className={rightRailStyles.right_rail_noAdsLayout}></div>
//     // </div>
//     <RightRailAds className={className} stickyTop={stickyTop} bottomBoundary={bottomBoundary}/>
//     );
//   }
// };

const renderEmptyDiv = (siteId, path) => {
  /* {/ Empty div to release sticky right rail ads, don't delete /} */
  if (siteId === Sites.EARLYBIRDBOOKS && path === "/") {
    return <div></div>;
  } else {
    return (
      <div className="empty">
        <br />
      </div>
    );
  }
};

const LayoutWithoutAds = (props) => {
  const {
    siteId,
    router,
    isMobile,
    isTablet: serverIsTablet,
    subscriberCookie,
    isNonClosableModalChecked,
    data,
    userAgent,
  } = useAppContext();

  // Enhanced client-side tablet detection using custom hook
  const { isTablet, isLargeTablet } = useTabletDetection(serverIsTablet, isMobile);

  useEffect(() => {
    if (!data?.SiteSettings?.gtm_container_id) return;

    // Delay GTM init until layout and page state are stable
    const id = data.SiteSettings.gtm_container_id;

    requestAnimationFrame(() => {
      TagManager.initialize({ gtmId: id });
    });
  }, [data?.SiteSettings?.gtm_container_id]);

  const [isDesktop, setIsDesktop] = useState(!isMobile && !isTablet);
  useEffect(() => {
    const isIPadProOnSafariDevice = isIPadProOnSafari(userAgent);
    const isDesktopDevice = !isMobile && !isTablet && !isIPadProOnSafariDevice;
    if (isDesktop !== isDesktopDevice) {
      setIsDesktop(isDesktopDevice);
    }
  }, []);

  // Part of older EBB homepage. See https://openroadmedia.atlassian.net/browse/ORMTECH-1810
  // let isHeader =
  //   siteId == Sites.EARLYBIRDBOOKS
  //     ? router.asPath == "/"
  //       ? isMobile
  //         ? true
  //         : false
  //       : true
  //     : true;
  const isHeader = siteId == Sites.EARLYBIRDBOOKS ? false : true;
  const hideHeader = props.hideHeader || false;
  const paddingClass = (!subscriberCookie) ? (siteId === Sites.OPENROADMEDIA ? styles.padding30 : styles.padding52) : styles.padding0;

  const customStyles = {
    display: 'flex',
    margin: '1rem',
    // marginTop: '85px',
    justifyContent: 'center',
    overflow: 'hidden'
  }

  return (
    <React.Fragment>
      {isHeader ? (
        <>
          <Header
            isNonClosableModalChecked={isNonClosableModalChecked}
            hideHeader={hideHeader}
          />
          {(!isMobile && !isTablet) && (
            siteId === Sites.OPENROADMEDIA ? <CatalogHeader /> : <ContentHeader isMobile={isMobile} isTablet={isTablet} />
          )}

        </>

      ) : (
        <NewHeader />
      )}
      <div>
        <div className={[paddingClass].join(" ")} style={customStyles}>
          {props.children}
          {isDesktop && <RightRailAds stickyTop={75} bottomBoundary={".empty"} />}
        </div>
        {renderEmptyDiv(siteId, router?.asPath)}
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default LayoutWithoutAds;
